import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { AgentPermission, formatPermission } from './types';

export interface PermissionConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  toolName: string;
  requiredPermissions: AgentPermission[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function PermissionConfirmDialog({
  open,
  onOpenChange,
  toolName,
  requiredPermissions,
  onConfirm,
  onCancel,
}: PermissionConfirmDialogProps) {
  const handleCancel = () => {
    onCancel();
    onOpenChange(false);
  };

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Enable {toolName}?</AlertDialogTitle>
          <AlertDialogDescription>
            This tool requires the following permissions:
          </AlertDialogDescription>
        </AlertDialogHeader>

        <ul className="list-disc list-inside space-y-1 text-sm">
          {requiredPermissions.map((perm, index) => (
            <li key={index}>{formatPermission(perm)}</li>
          ))}
        </ul>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm}>
            Enable Tool
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
